<template>
  <div class="kpi_table--column">
    <div class="kpi_table--column--heading">
      <p>Average</p>
    </div>

    <template v-for="(row, key) in kpiRowInfo">
      <div
        v-if="doesUserHaveAccess(row.permissionCheck)"
        :key="key"
        class="kpi_table--column--cell"
      >
        <p>{{ calculateAverage(key) }}</p>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "StatsKpiColumnAverage",
  computed: {
    authUser() {
      return this.$store.getters.authUser;
    },
    kpiRowInfo() {
      return this.$store.getters["statsKpi/kpiRowInfo"];
    },
    goals() {
      return this.$store.getters["statsKpi/goals"]
    }
  },
  methods: {
    doesUserHaveAccess(rowPermissionCheck) {
      // If rowPermissionCheck is null then show row
      if (!rowPermissionCheck) return true;
      // If owner show all row
      if (this.authUser.is_owner) return true;
      // check if user has rowPermissionCheck
      return this.authUser[rowPermissionCheck];
    },
    calculateAverage(key) {
      const amounts = this.kpiRowInfo[key].amounts
      const total = amounts.reduce((a, b) => parseInt(a) + parseInt(b), 0)
      const length = amounts.length

      if (!length) return '-'

      if (isNaN(total)) return '-'

      return Math.round(total/amounts.length);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.kpi_table--column {
  flex: 0 0 $kpiColumnSkinny;

  &--cell {
    text-align: center;
    background-color: $grey-50;
  }
}
</style>
